export default __webpack_public_path__ + "static/media/Otherworldly Flute.d61c2d5e.jpg";